import type { FaireProductEntity } from "../../entity_types/product";

export const p_chg7se2my5: FaireProductEntity = {
  token: "p_chg7se2my5",
  type: "product",
  name: "16pc. Caramel Gift Box",
  brandName: "Annie B's",
  imageUrl:
    "https://cdn.faire.com/fastly/91a007f696f8a5aab518ef19ff79a71d0ab6bdb194bedcc9ae7e6df2877fdda6.jpeg",
  priceDollars: 0,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/65a292801d5eccad339a1d322567cedbd84c9b70599a5a34aa5671b5bb8b01cf.jpeg",
  weight: 1,
  dimensions: {
    width: 6,
    height: 6,
    depth: 4,
  },
  inStock: true,
};
